import http from '@/services/http'
import { intercom } from '@/services/url'

/**
 * get intercom config
 * @returns Promise<IInterComConfig>
 */
export const getIntercomConfig = () => http.admin.post<IInterComConfig>(intercom.getIntercomConfig, {})
